import React, { useState } from "react";
import { Tabs, message } from "antd";
import axios from "axios";
import RoleCreatingTab from "../../components/RoleCreatingTab/RoleCreatingTab";
import RoleEditingTab from "../../components/RoleEditingTab/RoleEditingTab";
import {
  getCreateRoleRoute,
  getUpdateRoleRoute,
  getAssignPermissionsToRoleRoute,
  getDeleteRoleRoute,
} from "../../lib/rolesRoutes";
import LocalStorageService from "../../../../services/LocalStorageService";

const { TabPane } = Tabs;

function RoleParametersContainer(props) {
  const { fetchRoles, roles, permissions } = props;
  const [roleName, setRoleName] = useState("");
  const [targetKeys, setTargetKeys] = useState();
  const [editedRoleName, setEditedRoleName] = useState();
  const [editedTargetKeys, setEditedTargetKeys] = useState([]);
  const [selectedRoleForEdit, setSelectedRoleForEdit] = useState();
  const buildReqBody = (roleAlias, permissionsArr = []) => ({
    alias: roleAlias,
    tenantId: LocalStorageService.getTenantId(),
    includedPermissions: permissionsArr.map((item) => ({
      id: item,
    })),
  });

  const handleChangeRoleName = (value) => {
    setRoleName(value);
  };

  const handleChangeRoleForEdit = (role) => {
    setSelectedRoleForEdit(role);
    setEditedTargetKeys(role.includedPermissions);
    setEditedTargetKeys(role.includedPermissions.map((item) => item.id));
    setEditedRoleName(role.alias);
  };

  const handleIncludeRoles = (values) => {
    setTargetKeys(values);
  };

  const handleEditRoleName = (value) => {
    setEditedRoleName(value);
  };

  const handleEditPermissions = (values) => {
    setEditedTargetKeys(values);
  };

  const handleCreateRole = async () => {
    if (roleName === "") {
      message.warning("Введите название новой роли");
      return false;
    }
    try {
      await axios.post(getCreateRoleRoute(), buildReqBody(roleName, targetKeys));
      message.success("Роль создана");
      fetchRoles();
      return true;
    } catch (e) {
      message.error("Ошибка создания роли");
      return false;
    }
  };

  const handleEditRole = async () => {
    if (editedRoleName === "") {
      message.warning("Название роли не может быть пустым");
      return false;
    }
    try {
      await axios.patch(
        getUpdateRoleRoute(selectedRoleForEdit.id),
        buildReqBody(editedRoleName, editedTargetKeys)
      );
      await axios.put(getAssignPermissionsToRoleRoute(selectedRoleForEdit.id, editedTargetKeys));
      message.success("Роль отредактирована");
      fetchRoles();
      return true;
    } catch (e) {
      message.error("Ошибка редактирования роли");
      return false;
    }
  };

  const handleDeleteRole = async () => {
    if (!selectedRoleForEdit) {
      message.warning("Выберите роль");
      return false;
    }
    try {
      await axios.delete(getDeleteRoleRoute(selectedRoleForEdit.id));
      message.success("Роль удалена");
      fetchRoles();
      return true;
    } catch (e) {
      message.error("Ошибка при удалении роли");
      return false;
    }
  };

  const renderRolesTabs = () => (
    <Tabs defaultActiveKey="1" type="card">
      <TabPane tab="Создание" key="1">
        <RoleCreatingTab
          targetKeys={targetKeys}
          handleChangeRoleName={handleChangeRoleName}
          handleIncludeRoles={handleIncludeRoles}
          handleCreateRole={handleCreateRole}
          roles={roles}
          permissions={permissions}
        />
      </TabPane>
      <TabPane tab="Редактирование" key="2">
        <RoleEditingTab
          editedTargetKeys={editedTargetKeys}
          handleEditRoleName={handleEditRoleName}
          handleEditPermissions={handleEditPermissions}
          handleChangeRoleForEdit={handleChangeRoleForEdit}
          editedRoleName={editedRoleName}
          handleEditRole={handleEditRole}
          roles={roles}
          permissions={permissions}
          handleDeleteRole={handleDeleteRole}
          selectedRoleForEdit={selectedRoleForEdit}
        />
      </TabPane>
    </Tabs>
  );

  return renderRolesTabs();
}

export default RoleParametersContainer;
